import React from 'react';
import { useNavigate } from 'react-router';

import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActionArea from '@mui/material/CardActionArea';

const appName = process.env.BRICATA_APPLIANCE_TYPE === 'mc2' ? 'MC2' : 'CMC';

const SUPPORT_PAGES = [
    { title: 'EULA', subheader: 'Read the End User License Agreement', link: '/support/eula' },
    // { title: 'Threat Analyst Guide', subheader: 'User Guide for Alert Monitoring, Threat Hunting, Policy Management, and Reporting', link: '/docs/UserGuide.pdf', newWindow: true },
    { title: 'API Documentation', subheader: `A RESTful API for the OpenText™ NDR ${appName}`, link: '/support/api_docs' },
    // { title: 'Zeek Scripting Guide', subheader: 'Introduction to Zeek Scripting with OpenText™ NDR', link: '/docs/ScriptingGuide.pdf', newWindow: true },
    { title: 'Tuning Policy Filter Reference', subheader: '', link: '/support/filter_reference' },
    { title: 'File Hash Configuration Reference', subheader: '', link: '/support/filehash' },
    { title: 'Third Party Licenses', subheader: '', link: '/docs/ThirdPartyLicenseDoc.pdf', newWindow: true },
];

const Support = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1);
    };

    const handleLink = (link, newWindow) => {
        newWindow ? window.open(link) : navigate(link);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} container justifyContent="flex-end">
                <Button aria-label="back" variant="contained" color="primary" onClick={handleBack}>Back</Button>
            </Grid>
            {SUPPORT_PAGES.map((v, i) => {
                return (
                    <Grid item xs={4} key={'support-page-card-' + i}>
                        <Card>
                            <CardActionArea aria-label={v.title} onClick={ () => { handleLink(v.link, v.newWindow) } } style={ { minHeight: '130px' } }>
                                <CardHeader title={v.title} subheader={v.subheader}></CardHeader>
                            </CardActionArea>
                        </Card>
                    </Grid>
                );
            })}
        </Grid>
    );
};

export default Support;
